import { ProductInterface } from '@graphcommerce/graphql-mesh'
import { useProductLink } from '@graphcommerce/magento-product'
import Script from 'next/script'

export function KlaviyoViewedProductTrackingScript(props: {
  product: Pick<
    ProductInterface,
    | 'uid'
    | 'name'
    | 'categories'
    | 'url_key'
    | 'free_shipping'
    | 'sku'
    | 'id'
    | 'media_gallery'
    | 'small_image'
    | 'price'
  >
}) {
  const { product } = props
  const productLink = `${process.env.NEXT_PUBLIC_CANONICAL_BASE_URL}p/${product.url_key}`
  const categories = product?.categories?.map((item) => item?.name).toString()
  const imageURL = (product?.media_gallery as any).at(0)?.url
  return (
    // eslint-disable-next-line @next/next/inline-script-id
    <Script>
      {`var klaviyo = window.klaviyo || [];
        var item = {
            "ProductName": "${product.name}",
            "ProductID": "${product.uid}",
            "SKU": "${product.sku}",
            "Categories": "${categories ?? ''}",
            "ImageURL": "${imageURL}",
            "URL":  "${productLink}",
            "Brand": "",
            "Price": "0",
            "CompareAtPrice": "0",

        };
        klaviyo.track("Viewed Product", item);`}
    </Script>
  )
}
